/**
 * Generated runtime TestId mirror for frontend/src/components/sources/AuthorityViolationsSection.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AuthorityViolationsSectionTestIds = {
  authorityViolationsList: "authority-violations-list",
  authorityViolationsTruncated: "authority-violations-truncated",
  sectionAuthorityViolations: "section-authority-violations",
  authorityViolationLink: (violation_entityId: string) => `authority-violation-link-${violation_entityId}`,
  authorityViolationLinkPrefix: () => "authority-violation-link-" as TestIdPrefix,
  authorityViolationRow: (violation_entityType: string, violation_entityId: string) => `authority-violation-row-${violation_entityType}-${violation_entityId}`,
  authorityViolationRowPrefix: () => "authority-violation-row-" as TestIdPrefix
} as const;
